import { Box, Button, Paper, Stack, Text } from "@mantine/core";
import GenerateCampaign from "../../onboarding/home/GenerateCampaign";
import { useProfileStore, useSessionStore } from "../../../../stores/UserStore";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useThemeStore } from "../../../../stores/ThemeStore";
import { lazy } from "react";
import { IconBrandYoutube } from "@tabler/icons-react";

const MainFeatures = lazy(() =>
  import("../../onboarding/mainFeatures/MainFeatures")
);

const MainImage = () => {
  const theme = useThemeStore((s) => s.theme);
  const mainColor = theme.colors.primary[6];
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 936.13137 505.29587"
    >
      <path
        d="M191.22942,619.35948l-2.92,14.65c-.22,1.12-.45,2.26-.7,3.39a14.28772,14.28772,0,0,0-7.34.41,68.511,68.511,0,0,1,5.04,8.43c-1.84,5.67-4.54,10.91-9.06,14.7a22.71964,22.71964,0,0,1-21.95,3.86l.13-.58c-4.86-9.43-2.22-21.32,3.82-30.03a58.3846,58.3846,0,0,1,10.85-11.47c4.07995-3.4,8.49-6.45,12.86-9.46A5.99007,5.99007,0,0,1,191.22942,619.35948Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e4e4e4"
      />
      <path
        id="b311a411-101b-4365-a37b-2cdfec47a637-5637"
        data-name="a4b268fa-75d0-4ac1-9d87-14bdca948464-2189"
        d="M155.33929,700.04932c-1.229-8.953-2.493-18.02-1.631-27.069.766-8.036,3.217-15.885,8.209-22.321a37.13173,37.13173,0,0,1,9.527-8.633c.953-.6,1.829.909.881,1.507a35.29987,35.29987,0,0,0-13.963,16.847c-3.04,7.732-3.528,16.161-3,24.374.317,4.967.988,9.9,1.665,14.83a.9.9,0,0,1-.61,1.074.878.878,0,0,1-1.074-.61Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#f2f2f2"
      />
      {/* <path
        d="M165.88665,250.986q64.2559-1.1173,128.52565-.321,64.26043.801,128.47773,3.52415,36.035,1.5282,72.04082,3.66151c1.92853.11411,1.92189-2.88628,0-3q-64.15339-3.79623-128.40043-5.6811-64.23792-1.8798-128.51292-1.83728-36.06741.024-72.13085.65375c-1.92833.03353-1.93442,3.03363,0,3Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      /> */}
      <path
        d="M464.42206,232.1752l18.73149-1.39412c1.91356-.14242,1.92908-3.14357,0-3l-18.73149,1.39412c-1.91356.14242-1.92908,3.14358,0,3Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M464.42206,250.1752l18.73149-1.39412c1.91356-.14242,1.92908-3.14357,0-3l-18.73149,1.39412c-1.91356.14242-1.92908,3.14358,0,3Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M463.01309,241.955,489.645,244.3745c1.92205.17461,1.9102-2.82646,0-3L463.01309,238.955c-1.922-.17461-1.9102,2.82646,0,3Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M176.97218,228.14065a6.6356,6.6356,0,0,0-6.13315,4.00554,5.97374,5.97374,0,0,0,1.37464,7.09581,7.1022,7.1022,0,0,0,6.72877,1.367,6.00261,6.00261,0,0,0,4.02336-5.64266,6.70726,6.70726,0,0,0-4.17854-6.469,1.50605,1.50605,0,0,0-1.84518,1.04766,1.54254,1.54254,0,0,0,1.04766,1.84518c.26142.101-.23881-.1285.00529.00448.10036.05468.20261.10408.30116.16246.08379.04963.164.10394.2455.15713.28.18276-.13669-.13416.04228.03012.15522.14248.309.28149.45006.43871.05335.05944.26234.2247.09993.10919-.12426-.08838-.04792-.0676-.00005.00337.03634.05386.07477.10625.11066.16044a5.3458,5.3458,0,0,1,.31836.55036c.02205.04387.0422.08877.06462.13243.042.0818.10289.10324.00414.00077-.09435-.0979-.03428-.09121-.00052.003.02219.06193.04641.12308.068.18523a5.782,5.782,0,0,1,.17685.6173c.022.09655.03967.19367.05856.29082.067.34448-.00973-.21415.00645.04173.01352.21364.02927.425.02555.63949q-.00255.14723-.0128.29409c-.00345.04884-.00889.09755-.01211.14639-.01555.23538-.01606-.086.01688-.108a2.77013,2.77013,0,0,0-.13555.617c-.02687.09326-.05878.18448-.08868.27672-.10435.32182.098-.17543-.01323.04454a5.48681,5.48681,0,0,1-.30646.5497c-.04887.07423-.23316.24186-.08246.1252.16353-.1266-.08574.09141-.13893.14751q-.10248.10809-.21273.20867a1.70367,1.70367,0,0,1-.14877.1293c-.00954-.00479.25061-.17374.1104-.08432-.17824.11368-.347.23528-.53484.33425-.02187.01152-.262.12277-.261.12671-.01036-.0405.30871-.11234.08969-.04157-.046.01486-.09113.03281-.13695.04826a4.90024,4.90024,0,0,1-.60932.1623c-.04725.00941-.09723.01419-.14378.02623-.15506.0401.14818-.02352.15729-.01826a1.30824,1.30824,0,0,0-.34135.03022,5.5808,5.5808,0,0,1-.639-.00006c-.04925-.00282-.09838-.00773-.14761-.01059-.1143-.00664-.19817-.089-.04607.0004.11735.069.10759.01866.00362-.00054-.04862-.009-.09747-.01658-.14608-.0257a5.82144,5.82144,0,0,1-.624-.15284c-.11033-.03362-.21843-.07272-.32727-.11076a.86911.86911,0,0,1-.138-.05312c-.00066-.01235.28052.13436.13207.05436-.18737-.101-.38113-.18564-.56409-.296-.09763-.0589-.19141-.12294-.28634-.186a.9227.9227,0,0,1-.11872-.085c.00314-.01268.23256.1999.11213.08514-.1523-.14515-.31522-.27508-.45946-.42964-.033-.03535-.06421-.07236-.09709-.10779l-.03184-.03638q-.12195-.14906-.00451.00143c.07949.02342.07587.11067.00044-.00265-.02688-.04038-.05545-.07959-.08227-.12a3.13367,3.13367,0,0,1-.31006-.55366c.00731-.00569.12994.36093.03617.08426-.01772-.05227-.03764-.10369-.055-.15609q-.0517-.15588-.091-.31524c-.02593-.10523-.03924-.21379-.06539-.31859-.04409-.17666.02575.13937.01779.1315-.025-.02471-.01436-.17791-.01623-.21457-.012-.23537.01482-.46383.019-.69778.00327-.18124-.015.14125-.01878.1318a.5081.5081,0,0,1,.02848-.15932c.02715-.12339.05242-.24665.08566-.36867q.05709-.20957.13146-.414c.01852-.051.0411-.10125.05833-.15267.06313-.18837-.125.22748-.02127.05764.14271-.23369.249-.48658.40052-.71737.0359-.05471.25421-.35945.13835-.20559-.11539.15325.11857-.13721.16286-.18652.184-.20489.40037-.3731.59087-.56928.11276-.11613-.07871.05718-.09.06526.059-.04215.11677-.0859.1765-.12706q.15621-.10767.32008-.20359c.12306-.07215.26221-.12586.38148-.20218.1409-.09017-.10776.03958-.11221.04229a1.11642,1.11642,0,0,1,.20093-.07659c.11615-.04119.62132-.25917.72729-.191-.0048-.00309-.38358.03048-.07738.01081.07236-.00465.14442-.0117.2169-.0147.14658-.00607.29266-.0024.43909.0052a1.50993,1.50993,0,0,0,1.5-1.5,1.5333,1.5333,0,0,0-1.5-1.5Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M197.97218,228.14065a6.6356,6.6356,0,0,0-6.13315,4.00554,5.97374,5.97374,0,0,0,1.37464,7.09581,7.1022,7.1022,0,0,0,6.72877,1.367,6.00261,6.00261,0,0,0,4.02336-5.64266,6.70726,6.70726,0,0,0-4.17854-6.469,1.50605,1.50605,0,0,0-1.84518,1.04766,1.54254,1.54254,0,0,0,1.04766,1.84518c.26142.101-.23881-.1285.00529.00448.10036.05468.20261.10408.30116.16246.08379.04963.164.10394.2455.15713.28.18276-.13669-.13416.04228.03012.15522.14248.309.28149.45006.43871.05335.05944.26234.2247.09993.10919-.12426-.08838-.04792-.0676-.00005.00337.03634.05386.07477.10625.11066.16044a5.3458,5.3458,0,0,1,.31836.55036c.02205.04387.0422.08877.06462.13243.042.0818.10289.10324.00414.00077-.09435-.0979-.03428-.09121-.00052.003.02219.06193.04641.12308.068.18523a5.782,5.782,0,0,1,.17685.6173c.022.09655.03967.19367.05856.29082.067.34448-.00973-.21415.00645.04173.01352.21364.02927.425.02555.63949q-.00255.14723-.0128.29409c-.00345.04884-.00889.09755-.01211.14639-.01555.23538-.01606-.086.01688-.108a2.77013,2.77013,0,0,0-.13555.617c-.02687.09326-.05878.18448-.08868.27672-.10435.32182.098-.17543-.01323.04454a5.48681,5.48681,0,0,1-.30646.5497c-.04887.07423-.23316.24186-.08246.1252.16353-.1266-.08574.09141-.13893.14751q-.10248.10809-.21273.20867a1.70367,1.70367,0,0,1-.14877.1293c-.00954-.00479.25061-.17374.1104-.08432-.17824.11368-.347.23528-.53484.33425-.02187.01152-.262.12277-.261.12671-.01036-.0405.30871-.11234.08969-.04157-.046.01486-.09113.03281-.13695.04826a4.90024,4.90024,0,0,1-.60932.1623c-.04725.00941-.09723.01419-.14378.02623-.15506.0401.14818-.02352.15729-.01826a1.30824,1.30824,0,0,0-.34135.03022,5.5808,5.5808,0,0,1-.639-.00006c-.04925-.00282-.09838-.00773-.14761-.01059-.1143-.00664-.19817-.089-.04607.0004.11735.069.10759.01866.00362-.00054-.04862-.009-.09747-.01658-.14608-.0257a5.82144,5.82144,0,0,1-.624-.15284c-.11033-.03362-.21843-.07272-.32727-.11076a.86911.86911,0,0,1-.138-.05312c-.00066-.01235.28052.13436.13207.05436-.18737-.101-.38113-.18564-.56409-.296-.09763-.0589-.19141-.12294-.28634-.186a.9227.9227,0,0,1-.11872-.085c.00314-.01268.23256.1999.11213.08514-.1523-.14515-.31522-.27508-.45946-.42964-.033-.03535-.06421-.07236-.09709-.10779l-.03184-.03638q-.12195-.14906-.00451.00143c.07949.02342.07587.11067.00044-.00265-.02688-.04038-.05545-.07959-.08227-.12a3.13367,3.13367,0,0,1-.31006-.55366c.00731-.00569.12994.36093.03617.08426-.01772-.05227-.03764-.10369-.055-.15609q-.0517-.15588-.091-.31524c-.02593-.10523-.03924-.21379-.06539-.31859-.04409-.17666.02575.13937.01779.1315-.025-.02471-.01436-.17791-.01623-.21457-.012-.23537.01482-.46383.019-.69778.00327-.18124-.015.14125-.01878.1318a.5081.5081,0,0,1,.02848-.15932c.02715-.12339.05242-.24665.08566-.36867q.05709-.20957.13146-.414c.01852-.051.0411-.10125.05833-.15267.06313-.18837-.125.22748-.02127.05764.14271-.23369.249-.48658.40052-.71737.0359-.05471.25421-.35945.13835-.20559-.11539.15325.11857-.13721.16286-.18652.184-.20489.40037-.3731.59087-.56928.11276-.11613-.07871.05718-.09.06526.059-.04215.11677-.0859.1765-.12706q.15621-.10767.32008-.20359c.12306-.07215.26221-.12586.38148-.20218.1409-.09017-.10776.03958-.11221.04229a1.11642,1.11642,0,0,1,.20093-.07659c.11615-.04119.62132-.25917.72729-.191-.0048-.00309-.38358.03048-.07738.01081.07236-.00465.14442-.0117.2169-.0147.14658-.00607.29266-.0024.43909.0052a1.50993,1.50993,0,0,0,1.5-1.5,1.5333,1.5333,0,0,0-1.5-1.5Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M218.97218,228.14065a6.6356,6.6356,0,0,0-6.13315,4.00554,5.97374,5.97374,0,0,0,1.37464,7.09581,7.1022,7.1022,0,0,0,6.72877,1.367,6.00261,6.00261,0,0,0,4.02336-5.64266,6.70726,6.70726,0,0,0-4.17854-6.469,1.50605,1.50605,0,0,0-1.84518,1.04766,1.54254,1.54254,0,0,0,1.04766,1.84518c.26142.101-.23881-.1285.00529.00448.10036.05468.20261.10408.30116.16246.08379.04963.164.10394.2455.15713.28.18276-.13669-.13416.04228.03012.15522.14248.309.28149.45006.43871.05335.05944.26234.2247.09993.10919-.12426-.08838-.04792-.0676-.00005.00337.03634.05386.07477.10625.11066.16044a5.3458,5.3458,0,0,1,.31836.55036c.02205.04387.0422.08877.06462.13243.042.0818.10289.10324.00414.00077-.09435-.0979-.03428-.09121-.00052.003.02219.06193.04641.12308.068.18523a5.782,5.782,0,0,1,.17685.6173c.022.09655.03967.19367.05856.29082.067.34448-.00973-.21415.00645.04173.01352.21364.02927.425.02555.63949q-.00255.14723-.0128.29409c-.00345.04884-.00889.09755-.01211.14639-.01555.23538-.01606-.086.01688-.108a2.77013,2.77013,0,0,0-.13555.617c-.02687.09326-.05878.18448-.08868.27672-.10435.32182.098-.17543-.01323.04454a5.48681,5.48681,0,0,1-.30646.5497c-.04887.07423-.23316.24186-.08246.1252.16353-.1266-.08574.09141-.13893.14751q-.10248.10809-.21273.20867a1.70367,1.70367,0,0,1-.14877.1293c-.00954-.00479.25061-.17374.1104-.08432-.17824.11368-.347.23528-.53484.33425-.02187.01152-.262.12277-.261.12671-.01036-.0405.30871-.11234.08969-.04157-.046.01486-.09113.03281-.13695.04826a4.90024,4.90024,0,0,1-.60932.1623c-.04725.00941-.09723.01419-.14378.02623-.15506.0401.14818-.02352.15729-.01826a1.30824,1.30824,0,0,0-.34135.03022,5.5808,5.5808,0,0,1-.639-.00006c-.04925-.00282-.09838-.00773-.14761-.01059-.1143-.00664-.19817-.089-.04607.0004.11735.069.10759.01866.00362-.00054-.04862-.009-.09747-.01658-.14608-.0257a5.82144,5.82144,0,0,1-.624-.15284c-.11033-.03362-.21843-.07272-.32727-.11076a.86911.86911,0,0,1-.138-.05312c-.00066-.01235.28052.13436.13207.05436-.18737-.101-.38113-.18564-.56409-.296-.09763-.0589-.19141-.12294-.28634-.186a.9227.9227,0,0,1-.11872-.085c.00314-.01268.23256.1999.11213.08514-.1523-.14515-.31522-.27508-.45946-.42964-.033-.03535-.06421-.07236-.09709-.10779l-.03184-.03638q-.12195-.14906-.00451.00143c.07949.02342.07587.11067.00044-.00265-.02688-.04038-.05545-.07959-.08227-.12a3.13367,3.13367,0,0,1-.31006-.55366c.00731-.00569.12994.36093.03617.08426-.01772-.05227-.03764-.10369-.055-.15609q-.0517-.15588-.091-.31524c-.02593-.10523-.03924-.21379-.06539-.31859-.04409-.17666.02575.13937.01779.1315-.025-.02471-.01436-.17791-.01623-.21457-.012-.23537.01482-.46383.019-.69778.00327-.18124-.015.14125-.01878.1318a.5081.5081,0,0,1,.02848-.15932c.02715-.12339.05242-.24665.08566-.36867q.05709-.20957.13146-.414c.01852-.051.0411-.10125.05833-.15267.06313-.18837-.125.22748-.02127.05764.14271-.23369.249-.48658.40052-.71737.0359-.05471.25421-.35945.13835-.20559-.11539.15325.11857-.13721.16286-.18652.184-.20489.40037-.3731.59087-.56928.11276-.11613-.07871.05718-.09.06526.059-.04215.11677-.0859.1765-.12706q.15621-.10767.32008-.20359c.12306-.07215.26221-.12586.38148-.20218.1409-.09017-.10776.03958-.11221.04229a1.11642,1.11642,0,0,1,.20093-.07659c.11615-.04119.62132-.25917.72729-.191-.0048-.00309-.38358.03048-.07738.01081.07236-.00465.14442-.0117.2169-.0147.14658-.00607.29266-.0024.43909.0052a1.50993,1.50993,0,0,0,1.5-1.5,1.5333,1.5333,0,0,0-1.5-1.5Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M522.34554,560.35206H154.44027a17.56665,17.56665,0,0,1-17.54737-17.54687V214.89943a17.56708,17.56708,0,0,1,17.54737-17.54737H522.34554a17.56707,17.56707,0,0,1,17.54736,17.54737V542.80519A17.56664,17.56664,0,0,1,522.34554,560.35206Zm-367.90527-361a15.56509,15.56509,0,0,0-15.54737,15.54737V542.80519a15.565,15.565,0,0,0,15.54737,15.54687H522.34554a15.565,15.565,0,0,0,15.54736-15.54687V214.89943a15.56509,15.56509,0,0,0-15.54736-15.54737Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M153.83072,420.458l129.37919-.39354,128.71909-.39154,72.61077-.22087a1.5009,1.5009,0,0,0,0-3l-129.37919.39355-128.71909.39153-72.61077.22087a1.5009,1.5009,0,0,0,0,3Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M219.10043,418.02586l.8-47.237c.03271-1.93121-2.96728-1.93159-3,0l-.8,47.237c-.03271,1.93121,2.96728,1.93158,3,0Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M280.93574,418.537l1.94957-59.37448.557-16.96414c.06341-1.931-2.93667-1.92873-3,0l-1.94957,59.37448-.557,16.96414c-.06341,1.931,2.93667,1.92873,3,0Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M342.60417,314.05333c-1.17594,21.03-3.35188,83.05995-4.52782,104.08992-.10787,1.929,2.89248,1.92287,3,0,1.17594-21.03,3.35188-83.05994,4.52782-104.08992.10787-1.929-2.89247-1.92287-3,0Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M403.97576,397.04114l-.36774,20.21318c-.03514,1.93123,2.96486,1.9314,3,0,.43432-23.87319,1.54814-23.095,1.67072-29.83275.03513-1.93123-2.96487-1.9314-3,0C405.27874,387.42157,404.41008,373.168,403.97576,397.04114Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M464.08772,343.94069l.33928,56.70864.09715,16.23815a1.5009,1.5009,0,0,0,3,0l-.33928-56.70864-.09715-16.23815a1.5009,1.5009,0,0,0-3,0Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M154.07194,418.77029c-2.48323-6.82393,3.11451-13.38719,8.8663-16.33636,6.891-3.53328,14.81824-4.33414,21.78229-7.7403,10.38228-5.078,17.9444-14.19152,24.67329-23.31385,6.92579-9.38927,13.26278-19.46629,22.06318-27.26763a44.19424,44.19424,0,0,1,16.06871-9.29914c7.50226-2.34128,15.4588-2.50189,23.21086-1.55834,16.01863,1.94973,30.868,8.56585,46.324,12.77089,14.57206,3.96456,30.62763,6.194,44.9307.02889,7.2669-3.13229,13.20938-8.38563,19.59206-12.93164a65.29581,65.29581,0,0,1,20.40827-9.84464c14.35794-3.99257,30.03794-2.92647,43.40518,3.823a58.2428,58.2428,0,0,1,27.46977,28.99246c6.33716,15.13848,5.5121,32.05568,3.442,47.9899-.5351,4.11874-1.17191,8.22371-1.81565,12.32661-.29634,1.88872,2.594,2.70228,2.89284.79752,2.578-16.43077,5.14772-33.38193,1.94028-49.9161A60.45584,60.45584,0,0,0,456.995,330.915a62.04356,62.04356,0,0,0-40.91133-12.91137,67.07853,67.07853,0,0,0-22.47417,4.99833c-7.41935,3.06889-13.702,7.61753-20.08361,12.40377-6.56132,4.921-13.325,8.99143-21.47108,10.59636-7.90151,1.55675-16.12137.97319-23.98827-.49665-16.23236-3.03284-31.36257-9.98514-47.45717-13.54734-14.91163-3.30038-31.0026-3.63015-44.35545,4.79389-10.27143,6.48-17.52933,16.53993-24.49477,26.25395-6.90438,9.62885-13.89606,19.92529-23.99209,26.50286-6.15873,4.01242-13.08185,5.49293-19.97135,7.74936-6.90729,2.26225-13.53837,6.07871-16.35476,13.15546a12.79371,12.79371,0,0,0-.26184,9.15423c.655,1.79995,3.55524,1.02278,2.89283-.79752Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="86.171 166.905 86.167 166.907 86.175 166.905 86.171 166.905"
        fill="#e6e6e6"
      />
      <path
        d="M223.30684,361.49757a5.96169,5.96169,0,0,0-7.22314-2.67334,5.24684,5.24684,0,0,0-2.98908,2.78314c-.05743.13605-.091.27912-.13787.41852-.065.1051-.14313.2-.20136.30994a5.95769,5.95769,0,0,0,9.29083,7.11792A6.41612,6.41612,0,0,0,223.30684,361.49757Zm-3.75726,2.54761c.01233.07574.00781.14532,0,0Zm-.3819-.86841c-.01471-.01691-.01287-.01507,0,0Zm-1.68335.67688c-.02252-.03467-.02472-.04047,0,0Zm.399.33826c.095.03235.05743.02557,0,0Zm.17816.0849.03949-.01807a.05015.05015,0,0,1-.02795-.00555l.00116-.00019.03094.00385.0058-.00263-.01788-.00415c.0155-.00054.01727.00159.01831.004.17846-.08172.05762-.04242-.04584-.01037l-.0069-.00159a.68136.68136,0,0,0-.20568-.066c-.0066-.00372-.01447-.00641-.02-.01038-.05744-.04089-.34772-.26764-.07843-.0299-.0586-.05176-.11652-.1026-.17164-.15845a.78291.78291,0,0,1-.088-.10815q-.053-.09091-.10278-.18342l-.005-.03326c-.00439-.02765-.00769-.03912-.01135-.05572.00171-.01716.00446-.03559.00714-.05347a.64632.64632,0,0,0,.03809-.16767l.0116-.01464c.04309-.06012.08081-.13025.12194-.19275-.2174.3302.085-.03644.10761-.08289.00384-.00793-.00287-.0036-.00122-.00909.00879-.00489.0061-.00153.01672-.00775.06738-.03968.13123-.08393.19965-.12183.08148-.04517.40246-.13629.06958-.04114.07562-.0216.14819-.04889.22461-.06885.01385-.0036.12591-.01928.18628-.03015.053-.00134.10443-.00293.10986-.00287.0249.00031.0498.00336.07471.00446-.05524.00739.18957.0603.26227.07147.01049.00824.01586.01355.03015.024.06146.04492.13623.08484.20111.12677-.2901-.1875.00378.01489.0592.07031.03314.03314.06366.06848.09485.10333a.8089.8089,0,0,1,.07727.106c.04755.08716.09815.17536.14813.26111l.01386.022a.08283.08283,0,0,0-.00043.00849,2.37222,2.37222,0,0,0,.11487.40777.33315.33315,0,0,1,.00568.03388c.00463.07617.011.1521.01116.2287l-.00067.0155A1.643,1.643,0,0,0,218.06148,364.27681Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M218.11458,364.2552c.00434.00134.00019.0011-.00079.00147Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M218.11348,364.25484l.0011.00036Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M218.11379,364.25667l-.00452.00073C218.115,364.258,218.11293,364.257,218.11379,364.25667Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="86.177 166.902 86.177 166.902 86.179 166.903 86.177 166.902"
        fill="#e6e6e6"
      />
      <polygon
        points="150.171 138.905 150.167 138.907 150.175 138.905 150.171 138.905"
        fill="#e6e6e6"
      />
      <path
        d="M287.30684,333.49757a5.96169,5.96169,0,0,0-7.22314-2.67334,5.24684,5.24684,0,0,0-2.98908,2.78314c-.05743.13605-.091.27912-.13787.41852-.065.1051-.14313.2-.20136.30994a5.95769,5.95769,0,0,0,9.29083,7.11792A6.41612,6.41612,0,0,0,287.30684,333.49757Zm-3.75726,2.54761c.01233.07574.00781.14532,0,0Zm-.3819-.86841c-.01471-.01691-.01287-.01507,0,0Zm-1.68335.67688c-.02252-.03467-.02472-.04047,0,0Zm.399.33826c.095.03235.05743.02557,0,0Zm.17816.0849.03949-.01807a.05015.05015,0,0,1-.028-.00555l.00116-.00019.03094.00385.0058-.00263-.01788-.00415c.0155-.00054.01727.00159.01831.004.17846-.08172.05762-.04242-.04584-.01037l-.0069-.00159a.68136.68136,0,0,0-.20568-.066c-.0066-.00372-.01447-.00641-.02-.01038-.05744-.04089-.34772-.26764-.07843-.0299-.0586-.05176-.11652-.1026-.17164-.15845a.78291.78291,0,0,1-.088-.10815q-.053-.09091-.10278-.18342l-.005-.03326c-.00439-.02765-.00769-.03912-.01135-.05572.00171-.01716.00446-.03559.00714-.05347a.64632.64632,0,0,0,.03809-.16767l.0116-.01464c.04309-.06012.08081-.13025.12194-.19275-.2174.3302.085-.03644.10761-.08289.00384-.00793-.00287-.0036-.00122-.00909.00879-.00489.0061-.00153.01672-.00775.06738-.03968.13123-.08393.19965-.12183.08148-.04517.40246-.13629.06958-.04114.07562-.0216.14819-.04889.22461-.06885.01385-.0036.12591-.01928.18628-.03015.053-.00134.10443-.00293.10986-.00287.0249.00031.0498.00336.07471.00446-.05524.00739.18957.0603.26227.07147.01049.00824.01586.01355.03015.024.06146.04492.13623.08484.20111.12677-.2901-.1875.00378.01489.0592.07031.03314.03314.06366.06848.09485.10333a.8089.8089,0,0,1,.07727.106c.04755.08716.09815.17536.14813.26111l.01386.022a.08283.08283,0,0,0-.00043.00849,2.37222,2.37222,0,0,0,.11487.40777.33315.33315,0,0,1,.00568.03388c.00463.07617.011.1521.01116.2287l-.00067.0155A1.643,1.643,0,0,0,282.06148,336.27681Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M282.11379,336.25667l-.00452.00073C282.115,336.258,282.11293,336.257,282.11379,336.25667Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="150.177 138.902 150.177 138.902 150.179 138.903 150.177 138.902"
        fill="#e6e6e6"
      />
      <path
        d="M282.11458,336.2552c.00434.00134.00019.0011-.00079.00147Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M282.11348,336.25484l.0011.00036Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="212.177 152.902 212.177 152.902 212.179 152.903 212.177 152.902"
        fill="#e6e6e6"
      />
      <path
        d="M349.30684,305.49757a5.96169,5.96169,0,0,0-7.22314-2.67334,5.24684,5.24684,0,0,0-2.98908,2.78314c-.05743.13605-.091.27912-.13787.41852-.065.1051-.14313.2-.20136.30994a5.95769,5.95769,0,0,0,9.29083,7.11792A6.41612,6.41612,0,0,0,349.30684,305.49757Zm-3.75726,2.54761c.01233.07574.00781.14532,0,0Zm-.3819-.86841c-.01471-.01691-.01287-.01507,0,0Zm-1.68335.67688c-.02252-.03467-.02472-.04047,0,0Zm.399.33826c.095.03235.05743.02557,0,0Zm.17816.0849.03949-.01807a.05015.05015,0,0,1-.028-.00555l.00116-.00019.03094.00385.0058-.00263-.01788-.00415c.0155-.00054.01727.00159.01831.004.17846-.08172.05762-.04242-.04584-.01037l-.0069-.00159a.68136.68136,0,0,0-.20568-.066c-.0066-.00372-.01447-.00641-.02-.01038-.05744-.04089-.34772-.26764-.07843-.0299-.0586-.05176-.11652-.1026-.17164-.15845a.78291.78291,0,0,1-.088-.10815q-.053-.09091-.10278-.18342l-.005-.03326c-.00439-.02765-.00769-.03912-.01135-.05572.00171-.01716.00446-.03559.00714-.05347a.64632.64632,0,0,0,.03809-.16767l.0116-.01464c.04309-.06012.08081-.13025.12194-.19275-.2174.3302.085-.03644.10761-.08289.00384-.00793-.00287-.0036-.00122-.00909.00879-.00489.0061-.00153.01672-.00775.06738-.03968.13123-.08393.19965-.12183.08148-.04517.40246-.13629.06958-.04114.07562-.0216.14819-.04889.22461-.06885.01385-.0036.12591-.01928.18628-.03015.053-.00134.10443-.00293.10986-.00287.0249.00031.0498.00336.07471.00446-.05524.00739.18957.0603.26227.07147.01049.00824.01586.01355.03015.024.06146.04492.13623.08484.20111.12677-.2901-.1875.00378.01489.0592.07031.03314.03314.06366.06848.09485.10333a.8089.8089,0,0,1,.07727.106c.04755.08716.09815.17536.14813.26111l.01386.022a.08283.08283,0,0,0-.00043.00849,2.37222,2.37222,0,0,0,.11487.40777.33315.33315,0,0,1,.00568.03388c.00463.07617.011.1521.01116.2287l-.00067.0155A1.643,1.643,0,0,0,344.06148,308.27681Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="212.171 152.905 212.167 152.907 212.175 152.905 212.171 152.905"
        fill="#e6e6e6"
      />
      <path
        d="M344.11348,350.25484l.0011.00036Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M344.11379,350.25667l-.00452.00073C344.115,350.258,344.11293,350.257,344.11379,350.25667Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M344.11458,350.2552c.00434.00134.00019.0011-.00079.00147Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M412.30684,382.49757a5.96169,5.96169,0,0,0-7.22314-2.67334,5.24684,5.24684,0,0,0-2.98908,2.78314c-.05743.13605-.091.27912-.13787.41852-.065.1051-.14313.2-.20136.30994a5.95769,5.95769,0,0,0,9.29083,7.11792A6.41612,6.41612,0,0,0,412.30684,382.49757Zm-3.75726,2.54761c.01233.07574.00781.14532,0,0Zm-.3819-.86841c-.01471-.01691-.01287-.01507,0,0Zm-1.68335.67688c-.02252-.03467-.02472-.04047,0,0Zm.399.33826c.095.03235.05743.02557,0,0Zm.17816.0849.03949-.01807a.05015.05015,0,0,1-.028-.00555l.00116-.00019.03094.00385.0058-.00263-.01788-.00415c.0155-.00054.01727.00159.01831.004.17846-.08172.05762-.04242-.04584-.01037l-.0069-.00159a.68136.68136,0,0,0-.20568-.066c-.0066-.00372-.01447-.00641-.02-.01038-.05744-.04089-.34772-.26764-.07843-.0299-.0586-.05176-.11652-.1026-.17164-.15845a.78291.78291,0,0,1-.088-.10815q-.053-.09091-.10278-.18342l-.005-.03326c-.00439-.02765-.00769-.03912-.01135-.05572.00171-.01716.00446-.03559.00714-.05347a.64632.64632,0,0,0,.03809-.16767l.0116-.01464c.04309-.06012.08081-.13025.12194-.19275-.2174.3302.085-.03644.10761-.08289.00384-.00793-.00287-.0036-.00122-.00909.00879-.00489.0061-.00153.01672-.00775.06738-.03968.13123-.08393.19965-.12183.08148-.04517.40246-.13629.06958-.04114.07562-.0216.14819-.04889.22461-.06885.01385-.0036.12591-.01928.18628-.03015.053-.00134.10443-.00293.10986-.00287.0249.00031.0498.00336.07471.00446-.05524.00739.18957.0603.26227.07147.01049.00824.01586.01355.03015.024.06146.04492.13623.08484.20111.12677-.2901-.1875.00378.01489.0592.07031.03314.03314.06366.06848.09485.10333a.8089.8089,0,0,1,.07727.106c.04755.08716.09815.17536.14813.26111l.01386.022a.08283.08283,0,0,0-.00043.00849,2.37222,2.37222,0,0,0,.11487.40777.33315.33315,0,0,1,.00568.03388c.00463.07617.011.1521.01116.2287l-.00067.0155A1.643,1.643,0,0,0,407.06148,385.27681Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="275.171 121.905 275.167 121.907 275.175 121.905 275.171 121.905"
        fill="#e6e6e6"
      />
      <path
        d="M407.11348,319.25484l.0011.00036Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M407.11379,319.25667l-.00452.00073C407.115,319.258,407.11293,319.257,407.11379,319.25667Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M407.11458,319.2552c.00434.00134.00019.0011-.00079.00147Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="275.177 121.902 275.177 121.902 275.179 121.903 275.177 121.902"
        fill="#e6e6e6"
      />
      <path
        d="M466.11348,339.25484l.0011.00036Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M471.30684,336.49757a5.96169,5.96169,0,0,0-7.22314-2.67334,5.24684,5.24684,0,0,0-2.98908,2.78314c-.05743.13605-.091.27912-.13787.41852-.065.1051-.14313.2-.20136.30994a5.95769,5.95769,0,0,0,9.29083,7.11792A6.41612,6.41612,0,0,0,471.30684,336.49757Zm-3.75726,2.54761c.01233.07574.00781.14532,0,0Zm-.3819-.86841c-.01471-.01691-.01287-.01507,0,0Zm-1.68335.67688c-.02252-.03467-.02472-.04047,0,0Zm.399.33826c.095.03235.05743.02557,0,0Zm.17816.0849.03949-.01807a.05015.05015,0,0,1-.028-.00555l.00116-.00019.03094.00385.0058-.00263-.01788-.00415c.0155-.00054.01727.00159.01831.004.17846-.08172.05762-.04242-.04584-.01037l-.0069-.00159a.68136.68136,0,0,0-.20568-.066c-.0066-.00372-.01447-.00641-.02-.01038-.05744-.04089-.34772-.26764-.07843-.0299-.0586-.05176-.11652-.1026-.17164-.15845a.78291.78291,0,0,1-.088-.10815q-.053-.09091-.10278-.18342l-.005-.03326c-.00439-.02765-.00769-.03912-.01135-.05572.00171-.01716.00446-.03559.00714-.05347a.64632.64632,0,0,0,.03809-.16767l.0116-.01464c.04309-.06012.08081-.13025.12194-.19275-.2174.3302.085-.03644.10761-.08289.00384-.00793-.00287-.0036-.00122-.00909.00879-.00489.0061-.00153.01672-.00775.06738-.03968.13123-.08393.19965-.12183.08148-.04517.40246-.13629.06958-.04114.07562-.0216.14819-.04889.22461-.06885.01385-.0036.12591-.01928.18628-.03015.053-.00134.10443-.00293.10986-.00287.0249.00031.0498.00336.07471.00446-.05524.00739.18957.0603.26227.07147.01049.00824.01586.01355.03015.024.06146.04492.13623.08484.20111.12677-.2901-.1875.00378.01489.0592.07031.03314.03314.06366.06848.09485.10333a.8089.8089,0,0,1,.07727.106c.04755.08716.09815.17536.14813.26111l.01386.022a.08283.08283,0,0,0-.00043.00849,2.37222,2.37222,0,0,0,.11487.40777.33315.33315,0,0,1,.00568.03388c.00463.07617.011.1521.01116.2287l-.00067.0155A1.643,1.643,0,0,0,466.06148,339.27681Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <polygon
        points="334.171 141.905 334.167 141.907 334.175 141.905 334.171 141.905"
        fill="#e6e6e6"
      />
      <polygon
        points="334.177 141.902 334.177 141.902 334.179 141.903 334.177 141.902"
        fill="#e6e6e6"
      />
      <path
        d="M466.11458,339.2552c.00434.00134.00019.0011-.00079.00147Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M466.11379,339.25667l-.00452.00073C466.115,339.258,466.11293,339.257,466.11379,339.25667Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M449.9376,385.08528l-46.49682,2.58432a1.02517,1.02517,0,0,1-.2217-2.03544l47.52456-7.73334Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#3f3d56"
      />
      <path
        d="M509.02823,488.60148l17.52161-29.4782,12.95055,6.11652s-22.31534,27.8716-23.02629,28.67345a6.857,6.857,0,1,1-7.44587-5.31177Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ffb6b6"
      />
      <path
        d="M516.31671,420.1259l28.38759,14.81061a15.7158,15.7158,0,0,1,2.66026,23.07858l-19.5701,22.4493-8.5256-11.55273,6.57123-13.73984-12.72381-3.35516Z"
        transform="translate(-131.93432 -197.35206)"
        fill={mainColor}
      />
      <path
        d="M435.41987,385.56689,432.22247,419.71l-14.32229.02391s8.21712-34.74593,8.51582-35.7751a6.857,6.857,0,1,1,9.00387,1.60813Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ffb6b6"
      />
      <path
        d="M463.92912,455.38874l-32.96452-6.04537c-13.88142-1.66929-19.57814-10.80283-17.07345-19.71158l8.06061-28.6703,12.65411,6.78416-.04865,15.2303,17.71307-2.42166Z"
        transform="translate(-131.93432 -197.35206)"
        fill={mainColor}
      />
      <polygon
        points="318.501 493.992 309.437 493.992 305.125 459.03 318.503 459.03 318.501 493.992"
        fill="#ffb6b6"
      />
      <path
        d="M450.75485,700.80015l-27.87342-.00105v-.3525a10.84971,10.84971,0,0,1,10.84911-10.84894h.00068l5.09143-3.86263,9.4995,3.86322,2.43317.00008Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <polygon
        points="382.636 493.992 391.7 493.992 396.012 459.03 382.634 459.03 382.636 493.992"
        fill="#ffb6b6"
      />
      <path
        d="M514.251,700.80015l27.87342-.00105v-.3525a10.8497,10.8497,0,0,0-10.84911-10.84894h-.00067l-5.09144-3.86263-9.4995,3.86322-2.43317.00008Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M436.6606,630.69c.13386-1.99494,1.19824-13.02767,1.19824-13.02767l2.54945-23.39757,4.49339-62.02167,4.00519-16.30232,19.82578,7.72341,16.087-7.71206,19.12086,6.11232,14.88876,5.58329s.02548,2.39011.1402,5.27738c.153,3.77959.42064,8.41318,1.058,9.6178,1.06439,2.12881.79671,13.5567.79671,13.5567s1.058,23.25095,2.3901,25.80039,1.59975,7.85869,1.19825,8.92307,1.3321,28.9872,1.3321,28.9872,4.44946,49.413,1.65781,56.8638-13.34066,2.57019-13.34066,2.57019.50988-1.98857-2.54945-2.92551-12.3776-71.00212-12.3776-71.00212-1.7336-14.36616-3.327-18.48349-3.05932-15.68547-3.05932-15.68547-9.84087-19.14637-9.96835-23.40394c0,0-1.28749-3.98351-2.50483.40154s-4.80569,14.88876-4.80569,14.88876l-3.49911,12.90016L467.85305,595.208l-2.66417,16.22725s-3.98989,21.53644-4.62725,22.467,0,20.60592,0,20.60592-3.08481,16.75623-7.44439,19.68174-15.90977.04646-15.90977.04646S436.52674,632.6849,436.6606,630.69Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M451.48141,463.4844l-2.53328,32.81806-3.8061,3.939a3.67047,3.67047,0,0,0,.19226,5.286h0l-2.09691,3.59581-.74242,11.33014a6.15824,6.15824,0,0,0,5.69891,7.58983l65.63208,3.08345a6.15823,6.15823,0,0,0,6.39361-6.96235l-5.58086-42.01386V479.009l-2.49845-6.06691,1.28412-20.32414,2.98692-32.25875-17.36244-4.48476-9.41385-6.47691-16.35468.26039-9.92373,8.15016L450.125,419.88027l-10.00658,1.98907-1.27473,2.77028,2.54945-.55406,9.24061,36.04127Z"
        transform="translate(-131.93432 -197.35206)"
        fill={mainColor}
      />
      <circle cx="349.15767" cy="188.3819" r="19.26595" fill="#ffb6b6" />
      <path
        d="M476.447,403.75706l13.9197-.71c1.78357-.091,3.73022-.2485,5.02752-1.47587a7.61645,7.61645,0,0,0,1.57785-2.62117c1.28687-2.98916,2.57378-5.97839,3.82778-8.9815,1.73455-4.15394,3.43808-8.53993,2.99533-13.01965a8.28531,8.28531,0,0,0-2.40838-5.43091,4.59943,4.59943,0,0,0-5.5901-.56644,9.45237,9.45237,0,0,0-4.692-6.81251,14.4862,14.4862,0,0,0-8.26222-1.75172,19.94078,19.94078,0,0,0-11.35626,4.47585,24.64986,24.64986,0,0,1-2.89711,2.29575,4.5479,4.5479,0,0,1-3.53584.65422,2.55893,2.55893,0,0,1-1.87846-2.78916,4.92343,4.92343,0,0,0-1.25935,6.49978,4.54324,4.54324,0,0,1-4.44025-.5253,5.42846,5.42846,0,1,0,5.69282,9.18831c.84481,1.18329.5302,2.79132.42013,4.24107s.27874,3.25148,1.67635,3.65218c1.88945.5417,3.4199-2.0024,5.38528-1.9753a2.95555,2.95555,0,0,1,2.34381,1.51036,8.7243,8.7243,0,0,1,.93824,2.73911l2.51535,11.324"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M1019.19147,576.98891c0-2.98336-1.0019-5.40458-2.232-5.41012H681.61475c-1.23566.00554-2.232,2.42676-2.23753,5.41012V699.79837a1.11465,1.11465,0,0,1-1.00673,1.10966q-1.3501.12958-2.7002.24121c-.02229,0-.04454.00558-.06683.00558-.48977.0445-.97958.07789-1.46939.11686h-.00557q-.37793-.69876-.7471-1.4097a1.1195,1.1195,0,0,1-.12676-.51712V569.97022c0-.82379.03339-1.65312.089-2.4713a31.661,31.661,0,0,1,.41745-3.35073c.94065-5.17078,3.06686-8.67181,5.48251-8.68292h340.08141a2.6062,2.6062,0,0,1,1.02412.217,3.99262,3.99262,0,0,1,1.26349.885,7.83147,7.83147,0,0,1,1.24121,1.69761,22.34258,22.34258,0,0,1,2.34329,8.86661c0,.03339.00557.06679.00557.10018.07793.90172.11686,1.82009.11132,2.73849l.0779,11.92789.05011,7.11331.15029,22.3196.05565,7.926.2449,81.37464h0a1.1132,1.1132,0,0,1-1.11319,1.1132h-4.475a1.1132,1.1132,0,0,1-1.1132-1.1132Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M928.06752,499.652h-36.134a1.928,1.928,0,0,0-1.925,1.93v57.08105h39.989V501.582A1.929,1.929,0,0,0,928.06752,499.652ZM910.1221,532.08476a4.28685,4.28685,0,0,1-4.26683-4.26681v-6.5838a4.26681,4.26681,0,0,1,8.53363,0v6.5838a4.28679,4.28679,0,0,1-4.2668,4.26681Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <path
        d="M889.88448,556.83725v5.50719a1.07883,1.07883,0,0,0,1.07664,1.07662h38.08381a1.08205,1.08205,0,0,0,1.07662-1.07662v-5.50719Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#3f3d56"
      />
      <path
        d="M987.90215,410.57058H833.44347a5.01407,5.01407,0,0,0-5.00608,5.00605V519.806a5.01087,5.01087,0,0,0,5.00608,5.006H987.90215a5.01086,5.01086,0,0,0,5.00607-5.006V415.57663A5.01406,5.01406,0,0,0,987.90215,410.57058Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e6e6e6"
      />
      <path
        d="M986.61286,414.18638H834.734a2.68306,2.68306,0,0,0-2.67724,2.6828V518.51512a2.68185,2.68185,0,0,0,2.67724,2.67723H986.61286a2.68184,2.68184,0,0,0,2.67723-2.67723V416.86918A2.68306,2.68306,0,0,0,986.61286,414.18638Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M957.02942,565.3374H866.66975a1.66223,1.66223,0,0,1-1.62659-2.00462l1.4021-6.65907a1.6694,1.6694,0,0,1,1.62631-1.31974h87.556a1.66942,1.66942,0,0,1,1.62631,1.31974l1.40209,6.65907a1.66222,1.66222,0,0,1-1.62658,2.00462Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <rect
        x="736.77892"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="742.3449"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="747.91088"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="753.47686"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="759.04284"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="764.60882"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="770.1748"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="775.74078"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="781.30676"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="786.87274"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="792.43872"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="798.0047"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="803.57069"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="809.13667"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="814.70265"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="820.26863"
        y="359.20098"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="736.71315"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="742.27913"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="747.84511"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="753.41109"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="758.97707"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="764.54305"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="770.10903"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="775.67501"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="781.24099"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="786.80697"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="792.37295"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="797.93893"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="803.50492"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="809.0709"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="814.63688"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="820.20286"
        y="361.98397"
        width="2.78299"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <rect
        x="763.42985"
        y="365.32356"
        width="22.26392"
        height="1.66979"
        rx="0.48819"
        fill="#e6e6e6"
      />
      <path
        d="M978.97816,428.19092H836.86568a.56528.56528,0,0,1,0-1.13028H978.97816a.56528.56528,0,0,1,0,1.13028Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#cacaca"
      />
      <ellipse
        cx="714.60514"
        cy="223.43727"
        rx="3.312"
        ry="3.38581"
        fill="#ccc"
      />
      <ellipse
        cx="726.04658"
        cy="223.43727"
        rx="3.312"
        ry="3.38581"
        fill="#ccc"
      />
      <ellipse
        cx="737.48802"
        cy="223.43727"
        rx="3.312"
        ry="3.38581"
        fill="#ccc"
      />
      <path
        d="M972.08945,418.24274H963.962a.61551.61551,0,0,0,0,1.23078h8.12741a.61551.61551,0,0,0,0-1.23078Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <path
        d="M972.08945,420.55272H963.962a.61552.61552,0,0,0,0,1.23079h8.12741a.61552.61552,0,0,0,0-1.23079Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <path
        d="M972.08945,422.85968H963.962a.61551.61551,0,0,0,0,1.23078h8.12741a.61551.61551,0,0,0,0-1.23078Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <rect
        x="767.289"
        y="261.62867"
        width="22.58782"
        height="4.83014"
        rx="2.41507"
        fill={mainColor}
      />
      <rect
        x="755.81742"
        y="271.28894"
        width="45.53098"
        height="4.83014"
        rx="2.41507"
        fill="#e6e6e6"
      />
      <rect
        x="755.81742"
        y="280.94922"
        width="45.53098"
        height="4.83014"
        rx="2.41507"
        fill="#e6e6e6"
      />
      <polygon
        points="524.726 431.447 516.54 427.531 527.785 393.314 539.867 399.092 524.726 431.447"
        fill="#ffb6b6"
      />
      <path
        d="M711.54262,623.28229c-.59529.37288-1.19058.73959-1.79189,1.10646-1.19664.73357-2.40523,1.45512-3.61387,2.16462-.60733.35482-1.22067.70965-1.828,1.05845v.01791l-.03608.006-.012.006-.926.22858-1.32887-3.5117-.61334-1.61748-.86589-2.291-1.58746-4.19111-8.35817-22.068,12.99427-3.205.48706,1.99036h.006l.2405.98608,4.53991,18.41214.926,3.7642.03006.11421.55921,2.24889.48108,1.94824.53513,2.1768Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ffb6b6"
      />
      <path
        d="M789.05859,545.78443c-.82379,1.32288-1.66564,2.63975-2.51347,3.94458q-2.36319,3.6439-4.85256,7.17962c0,.006-.006.006-.012.012a16.97642,16.97642,0,0,1-3.18693,2.32706c-.04811.03608-.10221.06012-.15032.09018a11.74913,11.74913,0,0,1-2.68185,1.07636c-.33673.08416-.67948.16835-1.01622.25254-1.21461.28862-2.41723.53518-3.61387.75164-2.12862.37883-4.23319.64942-6.32574.81777-.16838.01806-.33673.03006-.50511.04209-8.60473.63137-16.981-.38484-25.724-2.05044-4.31743-.81781-8.725-1.79794-13.28894-2.81416-1.49124-.33673-2.98849-.66744-4.5038-.99815-.11425-.024-.23452-.05414-.35479-.07818-2.16469-.475-4.36547-.94406-6.62037-1.40707-2.8382-.58326-5.76657-1.14849-8.80919-1.68366l.21646,4.28733a32.26822,32.26822,0,0,0,2.03243,9.639c1.29885,3.80027,2.32706,6.80681.15635,13.06642L706.25839,583.27a10.35021,10.35021,0,0,1-1.06432,9.15795l-.21045.31868,8.725,22.074.56523,1.43112h-4.46776l-5.49593.006H694.9959l-13.43927-26.9627-.64341-1.28681v-.06613l1.389-51.81475c.01805-.457.05413-.92.11425-1.377a15.7532,15.7532,0,0,1,5.99506-10.60705,15.17083,15.17083,0,0,1,11.29858-3.09074l4.6.59529,9.39846,1.21466,6.62037.85986.13231.018,19.52447,2.52551,1.40106-5.71243.25856-.0962,8.21991-3.01256,28.42985-10.42069.07216-.024,1.87006-.6855.22248.36077c.06617.10827.1323.2165.19242.32473a55.72845,55.72845,0,0,1,4.49179,10.42667,163.68257,163.68257,0,0,1,4.72026,18.02124q.08121.39687.14431.72158l.01806.06613c.018.10221.03006.16835.03607.18641A16.8184,16.8184,0,0,1,789.05859,545.78443Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M790.25853,526.68917c-.09022-.38485-.20447-.77567-.3247-1.1545a82.26988,82.26988,0,0,0-3.33123-8.43036c-1.41908-3.12681-3.1208-6.4761-5.1472-10.102q-1.47021-2.63376-3.16289-5.47791-.84785-1.42511-1.76183-2.90433a1.53038,1.53038,0,0,0-.07818-.13227l-.17436-.28861-28.12923,3.76419-10.47479,1.40106-.62535,5.21936-.15032,1.29282c-.006,0-.006,0,0,.006l-.42093,3.52366v.006l-.55921,4.65412-.04811-.006-15.54382-2.01436-16.01886-2.07453-8.60473-1.1124a15.16164,15.16164,0,0,0-11.29857,3.09073,15.76117,15.76117,0,0,0-5.995,10.60709c-.05413.42093-.09021.85385-.10827,1.28079l-8.11766,19.23586a124.10762,124.10762,0,0,0-9.176,36.10255l-5.953,19.03143.84783.07817,12.61544,1.17256,3.33124.3127,7.336-10.70931c.83583-1.22067,1.62956-2.47739,2.36916-3.7642a57.16729,57.16729,0,0,0,3.24106-6.5182l15.86854-37.76217q1.84.31578,3.64393.60131,8.34321,1.353,16.01887,2.20679c16.6382,1.85806,31.04556,2.00237,43.87148.427q5.40276-.65842,10.44473-1.73177,1.84906-.3879,3.64995-.83583c.28259-.06614.55921-.13227.83582-.20446a15.345,15.345,0,0,0,10.73335-10.02983A15.65694,15.65694,0,0,0,790.25853,526.68917Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M659.27551,623.21123l-8.85726-4.24524-1.389-.66744-2.21883,5.44785-15.48972,3.40945a3.67535,3.67535,0,0,0-.60131,6.99322l15.13493,6.17545,4.80445-4.32341-1.17858,5.80265,5.70039,2.32706,6.24757-19.88528Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <polygon
        points="581.774 417.469 582.34 418.9 581.774 418.9 581.774 417.469"
        fill="#2f2e41"
      />
      <path
        d="M710.62386,616.55758l-9.2808,3.21559-1.45663.50307,2.25657,5.43233-8.60767,13.32155a3.67535,3.67535,0,0,0,4.4933,5.39231l15.09969-6.26111.37189-6.45262,3.24539,4.95249,5.68793-2.35736-9.55231-18.52592Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M654.29426,417.60112a6.59162,6.59162,0,0,0,9.85736,2.23448L683.66723,432.791l.03722-12.17246L665.16639,410.182a6.62733,6.62733,0,0,0-10.87213,7.41908Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ffb6b6"
      />
      <path
        d="M668.87388,423.22728l9.10526-10.3586,37.07416,22.00944,49.14578-4.5007a16.619,16.619,0,0,1,18.06343,18.081h0a16.63668,16.63668,0,0,1-18.07975,15.0161l-55.35008-5.12316Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <path
        d="M782.94031,423.38713l-.08527-.10723h0a35.90712,35.90712,0,0,0-34.75218,18.00664l-4.17086,7.347c-13.49095,16.49312-3.68758,27.86723-3.10071,29.55866l-4.68285,21.59147,1.04956,7.226.52418,2.1465L791.17623,537.087c3.04333-14.62225.10065-27.08252-10.9867-36.60114L790.917,467.10773A47.01985,47.01985,0,0,0,782.94031,423.38713Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <path
        d="M740.43783,585.54392h-17.1461a3.917,3.917,0,0,1-3.87533-3.3671,87.17978,87.17978,0,0,1,0-23.47951,3.91726,3.91726,0,0,1,3.80956-3.3665c5.39475-2.41816,11.20436-2.41786,17.27088-.0003a3.87165,3.87165,0,0,1,2.94606,1.42077,3.96093,3.96093,0,0,1,.81741,3.30162,52.71012,52.71012,0,0,0,0,20.76834,3.96093,3.96093,0,0,1-.81741,3.30162A3.871,3.871,0,0,1,740.43783,585.54392Z"
        transform="translate(-131.93432 -197.35206)"
        fill={mainColor}
      />
      <path
        d="M738.64212,564.28232h-14.4314a.902.902,0,1,1,0-1.80393h14.4314a.902.902,0,1,1,0,1.80393Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M738.64212,571.498h-14.4314a.902.902,0,1,1,0-1.80393h14.4314a.902.902,0,1,1,0,1.80393Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M738.64212,578.71372h-14.4314a.902.902,0,1,1,0-1.80392h14.4314a.902.902,0,1,1,0,1.80392Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M657.43783,423.54392h-17.1461a3.917,3.917,0,0,1-3.87533-3.3671,87.17978,87.17978,0,0,1,0-23.47951,3.91726,3.91726,0,0,1,3.80956-3.3665c5.39475-2.41816,11.20436-2.41786,17.27088-.0003a3.87165,3.87165,0,0,1,2.94606,1.42077,3.96093,3.96093,0,0,1,.81741,3.30162,52.71012,52.71012,0,0,0,0,20.76834,3.96093,3.96093,0,0,1-.81741,3.30162A3.871,3.871,0,0,1,657.43783,423.54392Z"
        transform="translate(-131.93432 -197.35206)"
        fill={mainColor}
      />
      <path
        d="M655.64212,402.28232h-14.4314a.902.902,0,1,1,0-1.80393h14.4314a.902.902,0,1,1,0,1.80393Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M655.64212,409.498h-14.4314a.902.902,0,1,1,0-1.80393h14.4314a.902.902,0,1,1,0,1.80393Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M655.64212,416.71372h-14.4314a.902.902,0,1,1,0-1.80392h14.4314a.902.902,0,1,1,0,1.80392Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M356.43783,467.54392h-17.1461a3.917,3.917,0,0,1-3.87533-3.3671,87.17978,87.17978,0,0,1,0-23.47951,3.91726,3.91726,0,0,1,3.80956-3.3665c5.39475-2.41816,11.20436-2.41786,17.27088-.0003a3.87165,3.87165,0,0,1,2.94606,1.42077,3.96093,3.96093,0,0,1,.81741,3.30162,52.71012,52.71012,0,0,0,0,20.76834,3.96093,3.96093,0,0,1-.81741,3.30162A3.871,3.871,0,0,1,356.43783,467.54392Z"
        transform="translate(-131.93432 -197.35206)"
        fill={mainColor}
      />
      <path
        d="M354.64212,446.28232h-14.4314a.902.902,0,1,1,0-1.80393h14.4314a.902.902,0,1,1,0,1.80393Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M354.64212,453.498h-14.4314a.902.902,0,1,1,0-1.80393h14.4314a.902.902,0,1,1,0,1.80393Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M354.64212,460.71372h-14.4314a.902.902,0,1,1,0-1.80392h14.4314a.902.902,0,1,1,0,1.80392Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#fff"
      />
      <path
        d="M745.46161,563.62594a6.5916,6.5916,0,0,0,1.64575-9.97255l11.77477-20.24983-12.15324.685-9.31829,19.12456a6.62733,6.62733,0,0,0,8.051,10.41283Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ffb6b6"
      />
      <path
        d="M750.21291,548.73823l-10.88053-8.4747,19.77122-38.31459-7.40838-48.7922a16.619,16.619,0,0,1,16.97747-19.10428h0a16.63667,16.63667,0,0,1,16.06224,17.15706l-1.83044,55.55653Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <path
        d="M224.31966,538.26993a6.64617,6.64617,0,0,0-.92425-10.14919l10.582-52.56023-11.68584,3.752-8.4704,50.83891a6.68225,6.68225,0,0,0,10.49845,8.11854Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#9e616a"
      />
      <path
        d="M239.94458,427.06627l-7.25052-5.47306s-6.39609-.45294-7.5289,11.08163-3.45883,34.01358-3.45883,34.01358l-11.09474,51.38647,15.35812,3.371,11.88326-55.4551,7.12879-16.46808Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <polygon
        points="96.057 313.623 136.914 312.942 140.319 285.023 96.057 285.023 96.057 313.623"
        fill="#9e616a"
      />
      <polygon
        points="132.828 485.427 142.26 485.427 146.747 449.046 132.826 449.047 132.828 485.427"
        fill="#9e616a"
      />
      <polygon
        points="73.738 486.301 83.17 486.234 87.402 449.823 75.135 452.637 73.738 486.301"
        fill="#9e616a"
      />
      <polygon
        points="103.238 260.98 101.101 266.536 101.528 272.093 143.355 286.58 141.28 262.262 136.578 256.705 103.238 260.98"
        fill="#ffb6b6"
      />
      <circle cx="121.18221" cy="196.03649" r="14.93893" fill="#9e616a" />
      <path
        d="M262.42294,678.12643l14.91014-.88993v6.38815l14.17548,9.7901a3.99028,3.99028,0,0,1-2.26741,7.27391H271.49007l-3.05966-6.31886-1.19465,6.31886h-6.69287Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M202.4458,679.02206l14.90355-.99428.04471,6.388,14.24367,9.69063a3.99028,3.99028,0,0,1-2.21644,7.28961l-17.75064.12425-3.10383-6.29729-1.15038,6.32707-6.69271.04685Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M202.73736,655.75874l6.8681-54.89788,8.17141-57.8808c-5.98409-11.11333,7.49045-45.62369,7.49045-45.62369l1.902.09126,43.05,8.12158-.00928-.04143c8.80514,24.01585,11.72238,35.88019,11.23985,61.45474l-1.73467,91.935h.54417a3.40475,3.40475,0,0,1,0,6.80951H263.23565a3.40476,3.40476,0,1,1,0-6.80951h.43893L248.04884,549.45028l-13.24821,45.963L219.81972,655.3369c5.4476-1.3619,4.60175,1.79359,4.60175,3.58067a3.40476,3.40476,0,0,1-3.40476,3.40475H203.993a3.40121,3.40121,0,0,1-1.25559-6.56358Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M221.91528,499.144l1.36194-13.619a2.71478,2.71478,0,0,1,2.4549-2.03932c.56745-6.48761,2.95489-34.47566,3.09753-35.69629l.00557-.05162,1.08564-23.19163a3.42964,3.42964,0,0,1,3.20218-3.262l5.73413-.37481a.30343.30343,0,0,0,.29322-.30323,4.82207,4.82207,0,0,1,4.82205-4.8221h16.97689a4.51469,4.51469,0,0,1,4.47767,3.95212.29971.29971,0,0,0,.30506.26974l.002,0a8.06559,8.06559,0,0,1,8.11384,6.68989c2.32095,13.50393,6.97231,44.15273,4.6726,61.1917-.80056,5.93155.92521,1.2336,1.228,6.19651a3.65315,3.65315,0,0,1-.9095,2.64862,2.63369,2.63369,0,0,1,1.58533,3.34765l.29838-.07386a2.72377,2.72377,0,0,1-3.307,1.97535L233,508C231.5413,507.6323,221.54758,500.60264,221.91528,499.144Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <path
        d="M340.59989,443.772a6.64617,6.64617,0,0,1-9.35992,4.03141l-17.17084,15.67037L311.78928,451.414l16.666-12.99325a6.68225,6.68225,0,0,1,12.14465,5.35125Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#9e616a"
      />
      <path
        d="M280.83559,431.79406s-5.98735-13.53065-13.54943-10.84111-3.65762,15.81786-3.65762,15.81786l28.411,42.81149s40.97912-26.28757,35.99605-26.47325-6.47365-9.24886-6.47365-9.24886L299.90375,454.682l-.7328-3.85243-1.17455,1.17455-3.03091-2.38559Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#ccc"
      />
      <circle cx="638.68288" cy="198.72118" r="20.85682" fill="#ffb6b6" />
      <path
        d="M837.5538,426.76378a18.08782,18.08782,0,0,1-9.94255,7.00011,20.797,20.797,0,0,1-4.94982.8407,18.715,18.715,0,0,0-1.47122-5.49886,15.4508,15.4508,0,0,1-.7635,5.486,18.38753,18.38753,0,0,1-7.236-1.93873,15.945,15.945,0,0,1-8.53138-11.4438c-.88359-5.70476,1.70286-11.30656,2.63792-17.00271.93935-5.69617-.82354-12.91072-6.3996-14.4077-4.2464-1.14094-3.77029-.64766-7.30036,1.97308,3.672,5.42946-9.89092,25.32605-15.44141,23.591-3.13813-.98094-5.14714-3.86035-5.79482-3.86035-4.36219,7.5148,3.85176,20.17676-4.42654,22.80609l.682-.682c4.997-6.14652-5.44739-19.15592-.45037-25.30246,1.394-1.72,2.87809-3.75741,2.46633-5.93205-.39034-2.06744-3.67162-3.1612-4.63244-1.46266,1.72859-3.959-.82353-9.2434-5.04846-10.26-3.75312-.905-3.68451.21017-7.45048.69486a18.69,18.69,0,0,0-1.36828-4.7225,15.3235,15.3235,0,0,1-.5619,4.81258,6.04294,6.04294,0,0,1-3.65447-1.3211c-3.07111-2.47493-2.44919-7.67353.29167-10.50874,2.74515-2.83521,6.82426-3.85606,10.71461-4.51662,1.13094-7.87547,22.85981-8.697,25.74-.82783,1.22675-5.87632,8.58285-8.926,14.30047-7.103s9.6852,7.16311,11.77408,12.79064c2.08887,5.62324,2.67221,11.67543,3.959,17.53458s3.46146,11.82554,7.93946,15.81886c4.478,3.989,11.77408,5.31013,16.49229,1.60419A13.20769,13.20769,0,0,1,837.5538,426.76378Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M1033.22942,474.35948l-2.92,14.65c-.22,1.12-.44995,2.26-.69995,3.39a14.28772,14.28772,0,0,0-7.34.41,68.511,68.511,0,0,1,5.04,8.43c-1.84,5.67-4.54,10.91-9.06,14.7a22.71964,22.71964,0,0,1-21.95,3.86l.13-.58c-4.86-9.43-2.22-21.32,3.82-30.03a58.3846,58.3846,0,0,1,10.85-11.47c4.07995-3.4,8.49-6.45,12.86-9.46A5.99007,5.99007,0,0,1,1033.22942,474.35948Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#e4e4e4"
      />
      <path
        id="a7585634-9c2c-4d81-a429-c019b32aabf2-5638"
        data-name="a4b268fa-75d0-4ac1-9d87-14bdca948464-2189"
        d="M997.33929,555.04932c-1.229-8.953-2.493-18.02-1.631-27.069.766-8.036,3.217-15.885,8.209-22.321a37.13173,37.13173,0,0,1,9.527-8.633c.953-.6,1.829.909.881,1.507a35.29987,35.29987,0,0,0-13.963,16.847c-3.04,7.732-3.528,16.161-3,24.374.317,4.967.988,9.9,1.665,14.83a.9.9,0,0,1-.61,1.074.878.878,0,0,1-1.074-.61Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#f2f2f2"
      />
      <path
        d="M1066.875,702.3406l-933.75.30734a1.19069,1.19069,0,0,1,0-2.38137l933.75-.30734a1.19069,1.19069,0,0,1,0,2.38137Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#cacaca"
      />
      <path
        d="M235.53416,384.24148c-2.29115,1.09956-4.85587-.55463-6.83394-2.1938l.70759.6111c-3.496,3.40136-5.13049,8.295-5.92915,13.1122-.79946,4.81219-.8886,9.73349-1.89518,14.51148-1.00736,4.77294-3.097,9.5685-7.00017,12.49186-5.229,3.91551-12.44089,3.66418-18.8579,2.4639-.08549-.01739-.16516-.03053-.25065-.04792a39.17631,39.17631,0,0,0,2.06351-15.53107,35.62051,35.62051,0,0,1-8.55133,14.01635,81.77118,81.77118,0,0,1-12.41776-4.52484c-2.59486-1.19436-5.38892-2.82751-6.10908-5.59277-.722-2.74434.95459-5.62289,3.19644-7.35579s4.99335-2.637,7.54733-3.87152c2.54979-1.22872,5.073-2.98061,6.09393-5.62536,2.35472-6.084-4.35321-13.0653-1.739-19.04589,1.28916-2.94091,4.44678-4.54059,7.41464-5.7739a108.82521,108.82521,0,0,1,13.92569-4.69721c4.16318-1.09817,8.51015-1.95158,12.7512-1.2317s8.396,3.29944,9.92241,7.32712c2.54684.86075,5.25072,1.83091,6.88523,3.97468C238.09171,379.39715,237.96,383.07906,235.53416,384.24148Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
      <path
        d="M255.92053,377.19147c-6.5545-5.17444-11.85405-4.29114-15.9423-1.07639-.68728-.76456-3.61211,1.339-4.60242,1.03664l-3.58185,6.72422c-1.84318,3.25252-2.59937,6.57264-2.30142,8.44132-3.3904,9.50778,4.64952,15.92831,14.15749,19.31852a18.14268,18.14268,0,0,0,11.76508.1704l.11686-1.62011.72,1.32781s8.6921,17.89737,10.74606,18.70108c-1.24628-3.233-4.5334-18.59855-5.45092-21.80147-1.2581-4.35783-.39868-11.28126.34075-15.52611a24.0569,24.0569,0,0,0,.07136-7.91713l-.0183-.11474,2.03365,4.10533,4.563-2.86926C266.79366,381.01218,266.75885,374.93582,255.92053,377.19147Z"
        transform="translate(-131.93432 -197.35206)"
        fill="#2f2e41"
      />
    </svg>
  );
};

const ThingsToSetup = () => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);

  const profile = useProfileStore((s) => s.profile);

  return (
    <Paper
      component={Stack}
      // withBorder
      radius={12}
      pb="sm"
      pos={"relative"}
      align="center"
      justify="center"
      w={"65%"}
      style={{ overflow: "hidden" }}
    >
      <Text
        fz={24}
        fw={600}
        pos={"absolute"}
        top={0}
        left={2}
        c={"var(--mantine-color-gray-8)"}
        style={{ zIndex: 10 }}
      >
        {profile?.first_name && <>{profile?.first_name}, </>}
        {lang.home.welcome.replace("#", reseller?.name || " ")}
      </Text>
      <Stack pos={"absolute"} top={"23%"} left={"45%"} gap={"xs"}>
        <Button
          leftSection={<IconBrandYoutube size={22} />}
          component="a"
          href="https://youtu.be/_DpM0ouyqn0"
          target="_blank"
          variant="gradient"
          size={"xl"}
          radius="xl"
          gradient={{ from: "primary.4", to: "primary.5", deg: 90 }}
          display={reseller.name === "Magileads" ? "flex" : "none"}
        >
          {lang.home.watch}
        </Button>
        <GenerateCampaign />
        <MainFeatures />
      </Stack>

      <Box
        w={"60%"}
        maw={500}
        className="animate__animated animate__fadeInLeft"
        pos={"absolute"}
        bottom={0}
        left={"0%"}
      >
        <MainImage />
      </Box>
    </Paper>
  );
};

export default ThingsToSetup;
